//#region Libraries
import { Column } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
export const FormFields = styled(Column.withComponent("section"))`
    width: 90%;
    align-self: center;
    padding: 15px 10px;
    margin-bottom: 15px;
`;
export const Content = styled.section`
    width: 100%;
`;